import { useCallback } from 'react';
import { useQuery, useMutation } from 'convex/react';
import { api } from '@/convex/_generated/api';
import { Id } from '@/convex/_generated/dataModel';

export function useActiveContext() {
  const activeContext = useQuery(api.contexts.queries.getActiveContext);
  const switchContext = useMutation(api.contexts.switching.switchToContext);
  
  const switchTo = useCallback(async (contextId: Id<'contexts'>) => {
    try {
      await switchContext({ contextId });
      return true;
    } catch (error) {
      console.error('Failed to switch context:', error);
      return false;
    }
  }, [switchContext]);
  
  return {
    activeContext,
    switchTo,
    isLoading: activeContext === undefined,
  };
}

export function useUserContexts() {
  return useQuery(api.contexts.queries.getUserContexts);
}